import { useContext, useState, useEffect } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './index.css';
import { useHttp } from '@/shared/hooks/http.hook';
import { useMessage } from '@/shared/hooks/message.hook';
import { AuthContext } from '@/shared/context/AuthContext';
import Layout from 'antd/lib/layout/layout';
import { useNavigate } from 'react-router-dom';
import { PASSWORD_PATTERN } from '@/shared/utils/consts';
import { Captcha } from '@/shared/components/Captcha/Captcha';
import { ATTEMPTS_STORAGE_KEY, MAX_ATTEMPTS } from './LoginForm.constants';

const LoginForm = () => {
  const auth = useContext(AuthContext);
  const history = useNavigate();
  const message = useMessage();
  const { loading, error, request, clearError } = useHttp();
  const [form, setForm] = useState({
    email: null,
    password: null,
  });
  const [captcha, setCaptcha] = useState(false);

  useEffect(() => {
    error && message(error);
    clearError();
  }, [error, message, clearError]);

  const changeHandler = event => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const loginHandler = async () => {
    try {
      const data = await request('/api/auth/login', 'POST', { ...form });
      if (data.user) {
        sessionStorage.setItem(ATTEMPTS_STORAGE_KEY, 0);
        auth.login(data.tokens.access.token, data.user.id);
        history('/');
      } else {
        sessionStorage.setItem(ATTEMPTS_STORAGE_KEY, (+sessionStorage[ATTEMPTS_STORAGE_KEY] || 0) + 1);
      }
    } catch (e) {
      console.log('error-loginHandler >>> ', e);
    }
  };

  return (
    <Layout className='login-form-container'>
      <Form
        name='normal_login'
        className='login-form'
        initialValues={{
          remember: true,
        }}
      >
        <Form.Item
          name='email'
          rules={[
            {
              type: 'email',
              message: 'Неверный адрес почты',
            },
            {
              required: true,
              message: 'Пожалуйста, введите почту',
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className='site-form-item-icon' />}
            placeholder='email'
            name='email'
            value={form.email}
            onChange={changeHandler}
          />
        </Form.Item>
        <Form.Item
          name='password'
          rules={[
            {
              min: 6,
              pattern: PASSWORD_PATTERN,
              message: 'Не менее 6 символов, минимум одна буква и одна цифра',
            },
            {
              required: true,
              message: 'Пожалуйста, введите пароль',
            },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className='site-form-item-icon' />}
            type='password'
            placeholder='Пароль'
            name='password'
            value={form.password}
            onChange={changeHandler}
          />
        </Form.Item>
        {(+sessionStorage[ATTEMPTS_STORAGE_KEY] || 0) > 0 && (
          <p className='incorrectPasswordLabel'>Неверный логин или пароль!</p>
        )}
        {(+sessionStorage[ATTEMPTS_STORAGE_KEY] || 0) >= MAX_ATTEMPTS && <Captcha onCaptchaChange={setCaptcha} />}
        <Form.Item>
          <Form.Item name='remember' valuePropName='checked' noStyle>
            <Checkbox>Запомнить</Checkbox>
          </Form.Item>
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            className='login-form-button'
            onClick={() => {
              form.email && form.password && loginHandler();
            }}
            disabled={loading || (!captcha && (+sessionStorage[ATTEMPTS_STORAGE_KEY] || 0) >= MAX_ATTEMPTS)}
            loading={loading}
          >
            Войти
          </Button>
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default LoginForm;
